import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import { bankApplicationsApi } from '@modules/opportunities/entities/bankApplication/api';
import { t } from 'i18next';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';
import { UploadTitleDeedBody } from '../api/dto/uploadTitleDeed.dto';

const baseTranslation = 'opportunity.caseDetails.caseProgression.titleDeed.notification';

const useUploadTitleDeed = (opportunityExternalId: string) => {
  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['UploadedTitleDeed'],
    mutationFn: (requestBody: UploadTitleDeedBody) => {
      // Track attempt
      trackAmplitudeEvent(
        USER_EVENTS.CASE.CASE_BANK_TITLE_DEED_UPLOAD_ATTEMPTED,
        {
          useContext: true,
          addToContext: true,
          case_id: opportunityExternalId,
        }
      );

      const formData = new FormData();
      formData.append('title_deed', requestBody.titleDeed);
      return bankApplicationsApi.uploadTitleDeed({
        opportunityExternalId,
        bankApplicationExternalId: requestBody.bankApplicationExternalId,
        requestBody: formData,
      });
    },
    onSuccess: () => {
      // Track success
      trackAmplitudeEvent(
        USER_EVENTS.CASE.CASE_BANK_TITLE_DEED_UPLOAD_COMPLETED,
        { useContext: true }
      );

      toast('info', { message: t(`${baseTranslation}.success`) });
    },
    onError: (err) => {
      // Track error
      trackAmplitudeEvent(USER_EVENTS.CASE.CASE_BANK_TITLE_DEED_UPLOAD_FAILED, {
        useContext: true,
        error_message: err.message ?? '',
      });

      if (err.statusCode === 500) {
        toast('error', { message: err.message });
      } else {
        toast('error', { message: err.message || t(`${baseTranslation}.failed`) });
      }
    },
  });

  return {
    mutate,
    error,
    isPending,
    mutateAsync,
  };
};

export default useUploadTitleDeed;
